import { useTranslation } from "react-i18next";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import Checkbox from "@/components/CheckBox/Checkbox";
import { ROUTES } from "@/shared";
import useResponse from "@/shared/hooks/useResponse";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { FILTER_NAMES } from "../types";

interface FilterCheckboxProps {
  filter: FILTER_NAMES;
  route: ROUTES;
}

const FilterCheckbox = ({ filter, route }: FilterCheckboxProps) => {
  const { t } = useTranslation();
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();

  const {
    params,
    setParams,
    fetchData,
    loading: isTableLoading
  } = useTableStoreByRoute(route);

  const filterObject = params.filters;

  const isChecked =
    Array.isArray(filterObject?.[filter]) && filterObject[filter].length > 0;

  const handleChange = (_e: any, checked: boolean) => {
    if (isTableLoading) return;

    const newValue = checked ? [{ id: filter, name: filter }] : [];

    const mergedFilters = {
      ...filterObject,
      [filter]: newValue
    };

    setParams({
      filters: mergedFilters,
      pageNumber: "1"
    });

    fetchData(getData, handleResponse);
  };

  return (
    <Checkbox
      id={`filter_checkbox_${filter}`}
      checked={isChecked}
      onChange={handleChange}
      label={t(`Filter##${filter}`)}
    />
  );
};

export default FilterCheckbox;
